import { render, staticRenderFns } from "./SlipConfirm.vue?vue&type=template&id=72e05056&scoped=true"
import script from "./SlipConfirm.vue?vue&type=script&lang=js"
export * from "./SlipConfirm.vue?vue&type=script&lang=js"
import style0 from "./SlipConfirm.vue?vue&type=style&index=0&id=72e05056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e05056",
  null
  
)

export default component.exports